<div id="headerWrapper"
    class="syndicated-header-wrapper"
    [@headerState]="stateName"
    (@headerState.done)="headerStateDone($event)">
    <app-script-loader [src]="syndicatedHeaderUrl"></app-script-loader>
</div>
